export const contributions = {
  INDEX: '/contributions',
}
